import React from 'react';
import { withTheme } from 'styled-components';
import { Tag } from 'core/components';

function SiteTag(props) {
  const { siteName, theme, style = {}, ...tagProps } = props;

  return (
    <Tag
      bg="transparent"
      title={siteName}
      color="site.text"
      style={{ borderColor: theme.colors.site.border, ...style }}
      minimal
      round
      ellipsis
      {...tagProps}
    >
      {siteName}
    </Tag>
  );
}

export default withTheme(SiteTag);
